// File: frontend/src/components/UploadSection/UploadAreaFile.js

import React from 'react';
import styles from './UploadAreaFile.module.css';

const UploadAreaFile = ({ file, onFileChange, onFileRemove, acceptedFileTypes }) => {
  const handleChange = () => {
    document.getElementById('fileInput').click();
  };

  return (
    <div className={styles.uploadAreaFile}>
      <div className={styles.fileInfo}>
        <div className={styles.fileIcon}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div className={styles.fileDetails}>
          <span className={styles.fileName}>{file.name}</span>
          <span className={styles.fileSize}>{(file.size / 1024).toFixed(0)} KB</span>
        </div>
      </div>
      <div className={styles.actions}>
        <button 
          type="button" 
          className={styles.actionButton} 
          onClick={handleChange}
          aria-label="Change file"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23 4V10H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 20V14H7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.51 9.00001C4.01717 7.56682 4.87913 6.2789 6.01547 5.27549C7.1518 4.27208 8.52547 3.58195 10.0083 3.26763C11.4911 2.95332 13.0348 3.02324 14.4761 3.46925C15.9175 3.91527 17.2124 4.72082 18.24 5.80001L23 10M1 14L5.76 18.2C6.78761 19.2792 8.08249 20.0848 9.52387 20.5308C10.9652 20.9768 12.5089 21.0467 13.9917 20.7324C15.4745 20.4181 16.8482 19.7279 17.9845 18.7245C19.1209 17.7211 19.9828 16.4332 20.49 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Change</span>
        </button>
        <button 
          type="button" 
          className={`${styles.actionButton} ${styles.deleteButton}`} 
          onClick={onFileRemove}
          aria-label="Remove file"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      <input
        id="fileInput"
        type="file"
        accept={acceptedFileTypes}
        style={{ display: 'none' }}
        onChange={(e) => onFileChange(e.target.files[0])}
      />
    </div>
  );
};

export default UploadAreaFile;